export default class TodoDetails {
    /**
     * @type {string}
     * @memberof TodoDetails
     * @name appName
     */
    public appName: string;
    /**
     * @type {string}
     * @memberof TodoDetails
     * @name bizNo
     */
    public bizNo: string;
    /**
     * @type {string}
     * @memberof TodoDetails
     * @name 内容
     */
    public content: string;
    /**
     * @type {string}
     * @memberof TodoDetails
     * @name 截止日期
     */
    public deadlineDate: string;
    /**
     * @type {boolean}
     * @memberof TodoDetails
     * @name 完成状态（完成/未完成）
     */
    public finishedState: boolean;
    /**
     * @type {string}
     * @memberof TodoDetails
     * @name ID
     */
    public id: string;
    /**
     * @type {string}
     * @memberof TodoDetails
     * @name markTime
     */
    public markTime: string;
    /**
     * @type {string}
     * @memberof TodoDetails
     * @name 小程序行为
     */
    public microAppAction: string;
    /**
     * @type {string}
     * @memberof TodoDetails
     * @name PC行为
     */
    public pcAction: string;
    /**
     * @type {boolean}
     * @memberof TodoDetails
     * @name 阅读状态
     */
    public readState: boolean;
    /**
     * @type {boolean}
     * @memberof TodoDetails
     * @name 接收状态
     */
    public receiveState: boolean;
    /**
     * @type {string}
     * @memberof TodoDetails
     * @name 发送时间
     */
    public sendTime: string;
    /**
     * @type {string}
     * @memberof TodoDetails
     * @name 系统名称
     */
    public systemName: string;
    /**
     * @type {string}
     * @memberof TodoDetails
     * @name 标题名称
     */
    public title: string;
    /**
     * @type {string}
     * @memberof TodoDetails
     * @name todoID
     */
    public todoId: string;
    /**
     * @type {number}
     * @memberof TodoDetails
     * @name todoID
     */
    public overDayNumber: number;
    constructor({
        appName = '',
        bizNo = '',
        content = '',
        deadlineDate = '',
        finishedState = false,
        id = '',
        markTime = '',
        microAppAction = '',
        pcAction = '',
        readState = true,
        receiveState = true,
        sendTime = '',
        systemName = '',
        title = '',
        todoId = '',
        overDayNumber = null
    } = {}) {
        this.appName = appName
        this.bizNo = bizNo
        this.content = content
        this.deadlineDate = deadlineDate
        this.finishedState = finishedState
        this.id = id
        this.markTime = markTime
        this.microAppAction = microAppAction
        this.pcAction = pcAction
        this.readState = readState
        this.receiveState = receiveState
        this.sendTime = sendTime
        this.systemName = systemName
        this.title = title
        this.todoId = todoId
        this.overDayNumber = overDayNumber
    }
}